export const ligainicial = "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/proc/";